import React from 'react';
import { Link, Text, StyleSheet } from '@react-pdf/renderer';
import { format } from '../../utils/locale';

const LinkValue = ({ text, emptyText, src, type }) => {
  let value = text;

  if (type) value = format(value, value, type);

  return (
    <Link src={src} style={styles.title}>
      {value && value}
      {!value && !emptyText && <Text style={styles.empty}>Empty</Text>}
      {emptyText && <Text style={styles.empty}>{emptyText}</Text>}
    </Link>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 12,
    fontWeight: 200
  },
  empty: {
    color: '#B1B1B1',
    fontStyle: 'italic'
  }
});

export default LinkValue;
